module.exports = __webpack_public_path__ + "static/media/further-link-indicator.7e53ae17.svg";